// src/context/AuthContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';

export const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

const DEMO_USERS = {
    student: {
        username: "demo-student",
        userId: "usr-student-01",
        groups: ["student"],
        role: "student",
        name: "Alex Johnson",
        given_name: "Alex",
        family_name: "Johnson",
        email: "student.demo@dormdish.com",
        profileComplete: true,
        profileVerified: true,
        verificationStatus: "approved",
        verificationNotes: null,
        serviceType: null,
        attributes: {
            given_name: "Alex",
            family_name: "Johnson",
            email: "student.demo@dormdish.com",
            "custom:role": "student"
        }
    },
    owner: {
        username: "demo-owner",
        userId: "owner-rajesh-001",
        groups: ["owner"],
        role: "owner",
        name: "Rajesh Sharma",
        given_name: "Rajesh",
        family_name: "Sharma",
        email: "owner.demo@dormdish.com",
        profileComplete: true,
        profileVerified: true,
        verificationStatus: "approved",
        verificationNotes: "Verified owner listing provider",
        serviceType: "both",
        attributes: {
            given_name: "Rajesh",
            family_name: "Sharma",
            email: "owner.demo@dormdish.com",
            "custom:role": "owner"
        }
    },
    admin: {
        username: "demo-admin",
        userId: "usr-admin-01",
        groups: ["admin"],
        role: "admin",
        name: "System Administrator",
        given_name: "System",
        family_name: "Admin",
        email: "admin@dormdish.com",
        profileComplete: true,
        profileVerified: true,
        verificationStatus: "approved",
        verificationNotes: null,
        serviceType: null,
        attributes: {
            given_name: "System",
            family_name: "Admin",
            email: "admin@dormdish.com",
            "custom:role": "admin"
        }
    }
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const saved = sessionStorage.getItem('dorm_dish_demo_user');
            if (saved && DEMO_USERS[saved]) {
                return DEMO_USERS[saved];
            }
        } catch (e) {}
        return null;
    });
    const [loading] = useState(false);

    const loginAsDemo = (role) => {
        const demoUser = DEMO_USERS[role] || DEMO_USERS.student;
        try {
            sessionStorage.setItem('dorm_dish_demo_user', role);
        } catch (e) {}
        setUser(demoUser);
        return demoUser;
    };

    const logout = async () => {
        try {
            sessionStorage.removeItem('dorm_dish_demo_user');
        } catch (e) {}
        setUser(null);
    };

    const refreshProfileStatus = useCallback(async () => {
        return true;
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, loading, refreshProfileStatus, loginAsDemo, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
